import { Box } from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridTreeNodeWithRender,
} from "@mui/x-data-grid";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ETheme } from "../../../shared/enums/user/ETheme";
import { EditIcon, TrashIcon } from "../../../shared/icons/Icons";
import { IUser } from "../../../shared/interfaces/user/IUser";
import { darkTheme, lightTheme } from "../../../shared/mui/theme";
import { RootState } from "../../../store/store";

export const useUserColumns = (
  setSelectedUser: (user: IUser) => void,
  setShowDeleteModal: (show: boolean) => void,
  hideActionColumn = false,
): GridColDef[] => {
  const { t } = useTranslation();
  const { userData } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  return [
    { field: "id", headerName: t("general.id"), width: 80 },
    {
      field: "displayName",
      headerName: t("general.displayName"),
      flex: 1,
      minWidth: 250,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => {
            navigate(`/user/update/${params?.row?.id}`);
            setSelectedUser(params?.row);
          }}
        >
          {params.value}
        </div>
      ),
    },

    {
      field: "email",
      headerName: t("general.email"),
      width: 250,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "phoneNumber",
      headerName: t("general.phoneNumber"),
      width: 250,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "actions",
      headerName: t("general.action"),
      width: 150,
      sortable: false,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <Box
          sx={{
            display: hideActionColumn ? "none" : "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          {/* Edit or View Icon */}
          <span
            style={{ cursor: "pointer", display: "flex" }}
            onClick={() => {
              navigate(`/user/update/${params?.row?.id}`);
            }}
          >
            <EditIcon
              fill={
                userData?.theme === ETheme.LIGHT
                  ? lightTheme.palette.text.primary
                  : darkTheme.palette.text.primary
              }
            />
          </span>

          <span
            style={{ cursor: "pointer" }}
            className={"ms-3 d-flex"}
            onClick={() => {
              setSelectedUser(params.row);
              setShowDeleteModal(true);
            }}
          >
            <TrashIcon
              fill={
                userData?.theme === ETheme.LIGHT
                  ? lightTheme.palette.text.primary
                  : darkTheme.palette.text.primary
              }
            />
          </span>
        </Box>
      ),
    },
  ];
};
